import { Form, message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router";
import ActionBar from "../../../../components/action-bar";
import ActionButton from "../../../../components/action-button";
import useDispatchWithResult from "../../../../hooks/useDispatchWithResult";
import {
  fetchDocumentos,
  fetchLicencas,
  fetchUnidades,
} from "../../../../store/empresa";
import unwrapAxiosPromise from "../../../../util/unwrapAxiosPromise";
import EmpresaUnidadeForm from "./_form";
import useModulo from "../../../../hooks/useModulo";

export default function EmpresaUnidadeCreatePage() {
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();
  const [form] = Form.useForm();
  const [loadingSave, setLoadingSave] = useState(false);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const { moduloBasePath } = useModulo();

  useEffect(() => {
    form.resetFields();
    setImmediate(() => document.querySelector("#apelido").focus());
  }, []);

  const handleFinish = (values) => {
    setLoadingSave(true);
    unwrapAxiosPromise(
      axios.post(`/empresas/${empresaId}/unidades`, values),
      form
    )
      .then((data) => {
        message.success(t("Registro incluído com sucesso"));
        history.replace(`${moduloBasePath}/empresas/${empresaId}/unidades`);
        dispatch(fetchUnidades({ empresaId }));
        dispatch(fetchLicencas({ empresaId }));
        dispatch(fetchDocumentos({ empresaId }));
      })
      .finally(() => setLoadingSave(false));
  };

  const handleCancel = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/unidades`);
  };

  const title = (
    <ActionBar>
      <ActionButton.Save onClick={form.submit} loading={loadingSave} />
      <ActionButton.Cancel onClick={handleCancel} disabled={loadingSave} />
    </ActionBar>
  );

  return (
    <EmpresaUnidadeForm
      autoFillByCnpj="overwrite"
      disabled={loadingSave}
      form={form}
      onFinish={handleFinish}
      title={title}
    />
  );
}
